import { Contrast } from "lucide-react";
import { Toggle } from "@/modern/components/ui/toggle";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { cn } from "@/modern/utils";
import { useEntityManagerEnhancedBorders } from "../hooks/useEntityManagerEnhancedBorders";

export function EnhancedBordersToggle() {
  const [enabled, setEnabled] = useEntityManagerEnhancedBorders();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Toggle
          variant="outline"
          size="sm"
          className={cn(
            "!h-8 !min-w-8 !px-2 focus-visible:ring-0 focus-visible:ring-offset-0",
            enabled
              ? "!border-primary/40 !bg-primary/20 !text-foreground shadow-none ring-1 ring-primary/25 hover:!bg-primary/30 hover:!text-foreground"
              : "!bg-transparent text-muted-foreground hover:!bg-muted hover:!text-muted-foreground",
          )}
          pressed={enabled}
          onPressedChange={setEnabled}
          aria-label={enabled ? "Enhanced borders on" : "Enhanced borders off"}
        >
          <Contrast className="size-3.5" />
        </Toggle>
      </TooltipTrigger>
      <TooltipContent>{enabled ? "Enhanced borders on" : "Enhanced borders off"}</TooltipContent>
    </Tooltip>
  );
}
